require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./configurations-add-custom-head-tags.json") })
        }
      }, "path---configurations-add-custom-head-tags");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---configurations-add-custom-head-tags!./.cache/json/configurations-add-custom-head-tags.json
// module id = 416
// module chunks = 231608221292675